/*
 * Ziyaretçi akışı — kendi pikselimiz (14 Ekim 2026). GA4 kullanılmaz.
 * Ziyaretçinin sayfadaki hareketlerini (sayfa açtı, varyant seçti, abonelik/tek seferlik, sepete ekledi, aradı,
 * ne kadar kaldı, nereye kadar indi) toplayıp ahtapot'a (/acik/zy) gönderir; ahtapot › Analiz › Ziyaretçiler'de
 * kişi kişi akış olarak görünür. Ödeme adımlarını tema göremez: onları Shopify "Müşteri etkinlikleri"ndeki
 * Petidi ödeme pikseli aynı ziyaretçi çerezini (pz_z) okuyarak gönderir.
 *
 * KURAL: Bu dosya hiçbir şeyi DEĞİŞTİRMEZ — yalnız dinler (yakalama aşamasında, pasif). Hiçbir tema koduna
 * bağımlı değil; içinde hata olursa sessizce susar, sayfa etkilenmez.
 * Kişisel veri: ad/e-posta/telefon/adres GÖNDERİLMEZ. Form alanlarının içeriği okunmaz (yalnız arama kutusu).
 * Arama talebi (18 Eki 2026): satmadığımız ürün arandığında "sayfa" olayına satilmiyor:1, öneri penceresinde çıkınca
 * arama {d, satilmiyor:1, k:'oneri'} — izin kuralları aynı (izinsiz ziyaretçiden gitmez).
 * Sepet değeri (17 Eki 2026): sepete ekleme / sepet değişikliği / sepet sayfası / "Ödemeye geç" olaylarına sepet TL'si (tl),
 * adet, ücretsiz kargoya kalan (kalan; 0 = eşik aşıldı), abonelik satırı (ab), kampanya indirimi (kmp) ve
 * sepet tokeni (ct — ?key= erişim anahtarı ATILIR) eklenir. ct, siparişi ahtapot'ta bu ziyaretçiye bağlar (orders/create):
 * ödeme pikseli çalışmasa da sipariş doğru ziyaretçide görünür. /cart.js yalnız OKUNUR (GET).
 * Tema editörü (design mode) ve çerez bandında analitiği reddeden ziyaretçi için çalışmaz; sayfa açıkken
 * reddederse o an durur, kuyruğu atar, pz_z/pz_o çerezlerini siler.
 * KVKK (17 Ekim 2026, kullanıcı onayı — 14 Eki'deki "seçim yapmamış ziyaretçi izlenir" kararının yerine): seçim YAPMAMIŞ
 * ziyaretçide hiçbir çerez/depo yazılmaz, hiçbir şey gönderilmez. Olaylar yalnız bellekte bekler; "Kabul" (ya da ayarlarda
 * Analiz açık) gelince çerezler yazılır ve bekleyenler gider; "Ret" gelince atılır; seçimsiz sayfadan çıkarsa kaybolur.
 * Eskiden seçimsizken yazılmış pz_z/pz_o çerezleri silinir. Reddedenle aynı: ondan da hiçbir şey gitmez (yalnız bandın
 * kimliksiz seçim sayacı, cerez-izni.liquid).
 * Kimliksiz sayaç (21 Eki 2026) ve kimliksiz sepete ekleme (24 Eki 2026): aşağıda, /acik/zy-anon.
 * A/B testi — yaşam tarzı görseli (31 Eki 2026): grubu layout/theme.liquid head betiği koyar (html.ab-yasam-a|b). Testteki
 * ürün sayfasında (galeri .pd__gtrack--ab) "sayfa" olayına abt:'yasam-A'|'yasam-B', o sayfanın kendi düğmesiyle sepete
 * eklemeye abt + abu (ürün no). Alan adı `ab` değil `abt`: `ab` sepet olaylarında abonelik satırı demek. İzin kuralları
 * aynı; izinsiz ziyaretçinin kimliksiz sinyaline yalnız ab (grup) + ah (ürün handle'ı) eklenir. Rapor: ahtapot › Analiz › A/B Testleri.
 */
(function () {
  'use strict';
  try {
    var C = window.PZ || {};
    if (C.kapali || (window.Shopify && window.Shopify.designMode)) return;
    // İç ziyaretçi (19 Eki 2026, kullanıcı): ?bensayma=1 ile bir kez girilen tarayıcı kalıcı olarak sayılmaz
    // (?bensayma=0 geri açar). Mağaza sahibi/ekip oturumları istatistiği şişiriyordu.
    try {
      var bs = /[?&]bensayma=([01])/.exec(location.search);
      if (bs) { if (bs[1] === '1') localStorage.setItem('petidi_bensayma', '1'); else localStorage.removeItem('petidi_bensayma'); }
      if (localStorage.getItem('petidi_bensayma') === '1') return;
    } catch (e) {}
    if (!window.JSON || !document.addEventListener) return;
    var UC = C.uc || 'https://ahtapot.petidi.workers.dev/acik/zy';
    var OTURUM_DK = 30;

    // A/B yaşam görseli: bu sayfa testte mi, hangi grup (depo okunamayan tarayıcı rastgele değil → ölçüme girmez)
    function abYasam() {
      try {
        if (!document.querySelector('.pd__gtrack--ab')) return null;
        var c = document.documentElement.classList;
        if (c.contains('ab-yasam-hata')) return null;
        return c.contains('ab-yasam-a') ? 'yasam-A' : c.contains('ab-yasam-b') ? 'yasam-B' : null;
      } catch (e) { return null; }
    }
    // Ürün kartına (öneri şeridi, hızlı ekle) son tıklama: o sepete ekleme test ürününün değil
    var sonKartTik = 0;
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (t && t.closest && t.closest('.pcard, [data-product-card]')) sonKartTik = Date.now();
        else if (t && t.closest && t.closest('[data-pd-addcart], [name="add"], .pd__addcart')) sonKartTik = 0;
      } catch (e) {}
    }, true);
    function abSepet() { var g = abYasam(); return g && Date.now() - sonKartTik > 60000 ? g : null; }

    // Çerez izni (snippets/cerez-izni.liquid, 14 Eki 2026): analitiği REDDEDEN ziyaretçi izlenmez. Seçim localStorage
    // 'petidi_cerez'e ve Shopify Customer Privacy API'sine yazılıyor; ikisinden biri "hayır" diyorsa yeter.
    // Henüz seçim yapmamış ziyaretçi izlenir (bant "Tümünü reddet" diyene kadar) — KULLANICI KARARI, 14 Eki 2026.
    function izinYok() {
      try {
        var y = JSON.parse(localStorage.getItem('petidi_cerez') || 'null');
        if (y && y.analytics === false) return true;
      } catch (e) {}
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.currentVisitorConsent === 'function' && (cp.currentVisitorConsent() || {}).analytics === 'no') return true;
      } catch (e) {}
      return false;
    }
    // Kimliksiz sayaç (21 Eki 2026, kullanıcı: "en azından kimliksiz kaç kişi girmiş nerden gelmiş görelim"; aynı gün
    // kullanıcı kararı: reddeden de kimliksiz sayılır). Seçim yapmayan ve reddeden: çerez/depo YAZMADAN sayfa başına tek
    // sinyal → /acik/zy-anon (d: secimsiz|red). Kişiyi sunucu günlük tuzlu özetle (IP+tarayıcı, saklanmaz) ayırır.
    // Kabul eden göndermez (tam sayaçta). 14 Eki "reddeden izlenmez" kararı kimlikli izleme için geçerli, o değişmedi.
    if (!izinVar() && !onizleme()) {
      try {
        var aq = new URLSearchParams(location.search), ar = '';
        try { ar = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
        if (ar === location.hostname) ar = '';
        var ag = JSON.stringify({
          v: 1, d: izinYok() ? 'red' : 'secimsiz', p: kirp(location.pathname, 200), r: kirp(ar, 100),
          u: { s: kirp(aq.get('utm_source'), 60), md: kirp(aq.get('utm_medium'), 60), c: kirp(aq.get('utm_campaign'), 80) },
          m: /Mobi|Android|iPhone/i.test(navigator.userAgent || '') ? 1 : 0, wd: navigator.webdriver ? 1 : 0,
          g: aq.get('gclid') ? 1 : 0, f: aq.get('fbclid') ? 1 : 0, a: kirp(aq.get('ads_kampanya'), 60),   // Google Ads son eki (26 Eki 2026)
          ab: abYasam() || undefined, ah: abYasam() ? anonHandle0(location.pathname) : undefined,   // A/B yaşam görseli (31 Eki 2026)
        });
        var AU = UC.replace(/\/acik\/zy$/, '/acik/zy-anon');
        var anonYolla = function (g) {
          if (!(navigator.sendBeacon && navigator.sendBeacon(AU, new Blob([g], { type: 'text/plain' })))) {
            fetch(AU, { method: 'POST', body: g, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
          }
        };
        anonYolla(ag);
        // Kimliksiz sepete ekleme (24 Eki 2026, mağaza sahibi onayı): izinli yoldaki aynı tetikleyici (ağ kaydında /cart/add —
        // ürün sayfası, kart, hızlı ekle, abonelik). Gönderilen yalnız ürün handle'ı + seçim durumu; çerez/depo YAZILMAZ.
        // Ürün: son 60 sn'de tıklanan ürün kartındaki /products/<handle> linki, yoksa ürün sayfasının adresi. Tek eylemdeki
        // birden çok /cart/add (hediye, Club satırı) 1,5 sn içinde tek sayılır. Bu arada kabul ederse tam sayaç devralır.
        var anonKart = null, anonSon = 0;
        var anonHandle = function (yol) { var m = /\/products\/([^\/?#]+)/.exec(yol || ''); try { return m ? kirp(decodeURIComponent(m[1]).toLowerCase(), 100) : ''; } catch (e) { return ''; } };
        document.addEventListener('click', function (ev) {
          try {
            var kart = ev.target && ev.target.closest && ev.target.closest('.pcard, [data-product-card]');
            var a = kart && kart.querySelector('a[href*="/products/"]');
            if (a) anonKart = { h: anonHandle(a.getAttribute('href')), t: Date.now() };
            else if (ev.target.closest && ev.target.closest('[data-pd-addcart], [name="add"], .pd__addcart')) anonKart = null;   // ürün sayfasının kendi düğmesi
          } catch (e) {}
        }, true);
        if (window.PerformanceObserver) {
          new PerformanceObserver(function (l) {
            try {
              var ekledi = l.getEntries().some(function (en) { return /\/cart\/add(\.js)?(\?|$)/.test(String(en.name || '')); });
              if (!ekledi || izinVar() || Date.now() - anonSon < 1500) return;
              anonSon = Date.now();
              var h = anonKart && Date.now() - anonKart.t < 60000 && anonKart.h ? anonKart.h : anonHandle(location.pathname);
              var abg = abSepet();
              anonYolla(JSON.stringify({ v: 1, k: 'sepet', u: h, d: izinYok() ? 'red' : 'secimsiz', p: kirp(location.pathname, 200),
                m: /Mobi|Android|iPhone/i.test(navigator.userAgent || '') ? 1 : 0, wd: navigator.webdriver ? 1 : 0, ab: abg || undefined }));
            } catch (e) {}
          }).observe({ type: 'resource', buffered: false });
        }
      } catch (e) {}
    }

    if (izinYok()) return;
    // Analitik izni açıkça VERİLMİŞ mi (bant "Tümünü kabul et" / ayarlarda Analiz açık)
    function izinVar() {
      try {
        var y = JSON.parse(localStorage.getItem('petidi_cerez') || 'null');
        if (y && y.analytics === true) return true;
      } catch (e) {}
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.currentVisitorConsent === 'function' && (cp.currentVisitorConsent() || {}).analytics === 'yes') return true;
      } catch (e) {}
      return false;
    }

    function rid(n) {
      var s = '', h = 'abcdefghijklmnopqrstuvwxyz0123456789';
      try {
        var a = new Uint8Array(n); (window.crypto || window.msCrypto).getRandomValues(a);
        for (var i = 0; i < n; i++) s += h[a[i] % 36];
      } catch (e) { for (var j = 0; j < n; j++) s += h[Math.floor(Math.random() * 36)]; }
      return s;
    }
    function cerezOku(ad) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + ad + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function cerezYaz(ad, deger, sn) {
      document.cookie = ad + '=' + encodeURIComponent(deger) + '; path=/; max-age=' + sn + '; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
    }

    // Ziyaretçi kimliği (1 yıl) ve oturum (30 dk hareketsizlikte yenilenir). Ödeme pikseli ikisini de çerezden okur.
    // Yalnız izin varken (kimlikKur); seçim bekleniyorsa (bekliyor) çerez yazılmaz, olaylar bellekte bekler.
    var zid = '', oid = '', yeniOturum = false, bekliyor = true;
    function kimlikKur() {
      if (!bekliyor) return;
      bekliyor = false;
      zid = cerezOku('pz_z');
      if (!/^[a-z0-9]{12,40}$/.test(zid)) zid = rid(20);
      cerezYaz('pz_z', zid, 31536000);
      oid = cerezOku('pz_o'); yeniOturum = !/^[a-z0-9]{8,40}$/.test(oid);
      if (yeniOturum) oid = rid(12);
      oturumTazele();
    }
    function oturumTazele() { if (!bekliyor) cerezYaz('pz_o', oid, OTURUM_DK * 60); }
    if (izinVar()) kimlikKur();
    else if (cerezOku('pz_z') || cerezOku('pz_o')) {
      // Eskiden (17 Eki öncesi) seçimsizken yazılmış kimlik: izin yokken tutulmaz
      document.cookie = 'pz_z=; path=/; max-age=0'; document.cookie = 'pz_o=; path=/; max-age=0';
    }
    var pid = rid(10);   // bu sayfa açılışı

    var kuyruk = [], gonderilen = 0, acilis = Date.now();
    var gorunurMs = 0, gorunurBas = document.visibilityState === 'visible' ? Date.now() : 0;
    var enDerin = 0, insan = false, hataSay = 0, cikisGitti = false;

    function anonHandle0(yol) { var m = /\/products\/([^\/?#]+)/.exec(yol || ''); try { return m ? kirp(decodeURIComponent(m[1]).toLowerCase(), 100) : ''; } catch (e) { return ''; } }
    function kirp(s, n) { s = String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n - 1) + '…' : s; }
    function ekle(a, ek) {
      if (durdu) return;
      var o = { t: Date.now(), a: a };
      if (ek) for (var k in ek) if (ek[k] != null && ek[k] !== '') o[k] = ek[k];
      if (bekliyor && kuyruk.length >= 200) return;   // seçim beklerken bellek sınırı
      kuyruk.push(o);
      if (kuyruk.length >= 25) gonder();
    }
    // Önizleme / staging teması (petidi.com/?preview_theme_id=… dahil): kayıt tutulur ama panelde varsayılan gizli
    function onizleme() {
      try { if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return true; } catch (e) {}
      return /shopifypreview\.com$|^[a-z0-9-]+\.myshopify\.com$/.test(location.hostname) || /[?&]preview_theme_id=/.test(location.search);
    }
    function ortam() {
      var n = navigator || {};
      return {
        ua: kirp(n.userAgent, 300), dil: n.language || '', ek: (screen.width || 0) + 'x' + (screen.height || 0),
        pn: (window.innerWidth || 0) + 'x' + (window.innerHeight || 0), dk: window.devicePixelRatio || 1,
        wd: n.webdriver ? 1 : 0, m: C.m || null, onz: onizleme() ? 1 : 0,
      };
    }
    var durdu = false;
    // Sonradan reddederse: dur, çerezleri sil, o ana kadar gönderilen kaydı da sildir (ahtapot zy_paket'ten bu zid)
    function dur() {
      if (durdu) return;
      durdu = true; kuyruk.length = 0;
      document.cookie = 'pz_z=; path=/; max-age=0'; document.cookie = 'pz_o=; path=/; max-age=0';
      if (bekliyor || !zid) return;   // hiç gönderilmedi → silinecek kayıt yok
      try { navigator.sendBeacon && navigator.sendBeacon(UC, new Blob([JSON.stringify({ v: 1, sil: 1, z: zid })], { type: 'text/plain' })); } catch (e) {}
    }
    // Seçim yapıldı: ret → dur; kabul → kimliği kur, bekleyen olaylara kimlik/oturum bilgisini ekleyip gönder
    function secimDegisti() {
      if (izinYok()) return dur();
      if (bekliyor && izinVar()) {
        kimlikKur();
        if (yeniOturum && kuyruk.length && kuyruk[0].a === 'sayfa') kuyruk[0].yeni = 1;
        gonder();
      }
    }
    document.addEventListener('visitorConsentCollected', secimDegisti);
    document.addEventListener('petidi:cerez', secimDegisti);
    function gonder() {
      if (durdu || !kuyruk.length || bekliyor) return;
      if (izinYok()) return dur();
      var paket = { v: 1, z: zid, o: oid, p: pid, u: location.pathname + location.search, e: kuyruk.splice(0, 50) };
      if (!gonderilen) paket.m = ortam();
      gonderilen++;
      var govde = JSON.stringify(paket);
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(UC, new Blob([govde], { type: 'text/plain' }))) return;
      } catch (e) {}
      try { fetch(UC, { method: 'POST', body: govde, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (e) {}
    }
    // Sepet özeti (Ajax /cart.js biçimi ya da temanın sepet sayfasında verdiği PZ.sepet). Kişisel veri yok.
    function sepetTokeni(t) { t = String(t || '').split('?')[0]; return /^[A-Za-z0-9-]{8,80}$/.test(t) ? t : null; }
    function sepetOzet(c) {
      if (!c || typeof c.total_price !== 'number') return null;
      var tl = Math.round(c.total_price) / 100, ab = 0, kmp = 0;
      (c.items || []).forEach(function (it) {
        if (it.properties && it.properties._duzenli_hafta) ab = 1;
        // Abonelik kodu (DT…/ABONE…) kampanya sayılmaz; ürünün otomatik indirimi sayılır
        (it.discounts || []).concat((it.line_level_discount_allocations || []).map(function (a) { return { title: a.discount_application && a.discount_application.title }; }))
          .forEach(function (d) { if (d && !/^(DT|ABONE)/i.test(d.title || '')) kmp = 1; });
      });
      var o = { tl: tl, adet: c.item_count || 0, ab: ab, kmp: kmp };
      var esik = +C.esik || 0;
      if (esik > 0) o.kalan = Math.max(0, Math.round((esik - tl) * 100) / 100);   // Club üyesi de eşiğe tabi (30 Eki 2026)
      if (C.club) o.club = 1;
      var ct = sepetTokeni(c.token || cerezOku('cart'));
      if (ct) o.ct = ct;
      return o;
    }
    var sonSepet = null;
    if (C.sepet) { sonSepet = sepetOzet(C.sepet); }
    // Olay kuyruğa hemen girer (sayfa kapanırsa kaybolmasın); /cart.js gelince alanlar eklenir. Olay o arada gönderildiyse
    // değer ayrı 'sepet_deger' olayıyla gider.
    var sepetZam = 0;
    function sepetIleEkle(a, ek) {
      var o = { t: Date.now(), a: a };
      if (ek) for (var ek1 in ek) if (ek[ek1] != null) o[ek1] = ek[ek1];
      if (durdu || (bekliyor && kuyruk.length >= 200)) return;
      kuyruk.push(o);
      clearTimeout(sepetZam);
      sepetZam = setTimeout(function () {
        try {
          fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            var oz = sepetOzet(c);
            if (!oz) return;
            sonSepet = oz;
            if (kuyruk.indexOf(o) >= 0) { for (var k in oz) o[k] = oz[k]; } else ekle('sepet_deger', oz);
          }).catch(function () {});
        } catch (e) {}
      }, 400);
    }

    function gorunurEkle() { if (gorunurBas) { gorunurMs += Date.now() - gorunurBas; gorunurBas = 0; } }

    // 1) Sayfa açıldı
    var sayfa = { b: kirp(document.title, 140), tip: C.t || '' };
    var ref = document.referrer || '';
    try { if (ref && new URL(ref).hostname === location.hostname) sayfa.ic = 1; } catch (e) {}
    if (ref) sayfa.r = kirp(ref, 400);
    if (yeniOturum) sayfa.yeni = 1;
    if (C.urun) sayfa.urun = C.urun;
    var abs = abYasam(); if (abs) sayfa.abt = abs;
    if (C.koleksiyon) sayfa.kol = C.koleksiyon;
    if (C.arama) sayfa.q = kirp(C.arama, 80);
    // Satmadığımız ürün arandı (18 Eki 2026, main-search data-alaka="S|…" — snippets/arama-alaka): talep görünsün
    try { if (C.arama && document.querySelector('[data-coll][data-alaka^="S|"]')) sayfa.satilmiyor = 1; } catch (e) {}
    if (sonSepet) for (var sk in sonSepet) sayfa[sk] = sonSepet[sk];   // sepet sayfası: sepetin değeri
    ekle('sayfa', sayfa);
    // İlk paket hemen gitsin: sayfa tek görüntülenip kapansa da ziyaret kaydı olsun
    setTimeout(gonder, 50);

    // 2) İnsan sinyali (bot ayıklaması için): ilk gerçek dokunuş / kaydırma / tuş
    function insanOldu() { if (insan) return; insan = true; ekle('insan'); }
    ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (ad) {
      document.addEventListener(ad, insanOldu, { capture: true, passive: true, once: true });
    });

    // 3) Kaydırma derinliği (%25 / 50 / 75 / 100)
    function derinlik() {
      var h = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
      var g = window.innerHeight || 0, y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (h <= g) return;
      var yuzde = Math.min(100, Math.round(((y + g) / h) * 100));
      [25, 50, 75, 100].forEach(function (es) { if (yuzde >= es && enDerin < es) { enDerin = es; ekle('kaydir', { d: es }); } });
    }
    var kzam = 0;
    window.addEventListener('scroll', function () { if (kzam) return; kzam = setTimeout(function () { kzam = 0; derinlik(); }, 400); }, { passive: true });

    // 4) Tıklamalar: anlamlı olanlara ad ver, gerisini metniyle yaz
    function etiket(el) {
      return kirp(el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || el.value || el.alt || '', 70);
    }
    document.addEventListener('click', function (ev) {
      try {
        var el = ev.target && ev.target.closest && ev.target.closest('a, button, [role="button"], summary, label, [data-thumb]');
        if (!el) return;
        if (el.matches('label') && el.querySelector('input, select')) return;   // değişikliği 'change' yazar
        if (el.hasAttribute('data-sepet-yardim-link') || el.hasAttribute('data-sepet-yardim-kapat')) return;   // 'sepet_yardim' yazar
        if (el.hasAttribute('data-variant-id') && el.closest('.pd, [data-pd], main')) {
          var fiyat = el.getAttribute('data-price');
          return ekle('varyant', { d: kirp(el.getAttribute('aria-label') || el.textContent, 60), f: fiyat || null, yok: el.getAttribute('data-available') === '0' ? 1 : null });
        }
        if (el.hasAttribute('data-pd-addcart') || el.matches('[name="add"], .pd__addcart')) {
          var sec = document.querySelector('.pd__variant.is-selected, [data-variant-id][aria-pressed="true"]');
          var dt = document.querySelector('[data-dt-radio]:checked');
          return ekle('sepete_tik', { d: sec ? kirp(sec.getAttribute('aria-label'), 60) : null, s: dt ? (dt.value === 'duzenli' ? 'abonelik' : 'tek') : null });
        }
        if (el.hasAttribute('data-thumb')) return ekle('tik', { d: 'Görsel ' + (+el.getAttribute('data-thumb') + 1), k: 'galeri' });
        if (el.hasAttribute('data-quiz-open')) return ekle('tik', { d: 'Hangi mama? testini açtı', k: 'quiz' });
        var a = el.closest('a');
        var o = { d: etiket(el) };
        if (a && a.getAttribute('href')) {
          var h = a.getAttribute('href');
          try { var hu = new URL(h, location.href); o.h = hu.hostname === location.hostname ? hu.pathname + hu.search : hu.hostname + hu.pathname; } catch (e) { o.h = kirp(h, 120); }
        }
        if (!o.d && !o.h) return;
        if (el.closest('header, .header, [role="banner"]')) o.k = 'menu';
        else if (el.closest('footer, .footer')) o.k = 'alt';
        ekle('tik', o);
      } catch (e) {}
    }, true);

    // 5) Seçimler: abonelik / tek seferlik, teslimat sıklığı, kutucuklar, açılır listeler (arama kutusu dışında DEĞER okunmaz)
    document.addEventListener('change', function (ev) {
      try {
        var el = ev.target;
        if (!el || !el.matches) return;
        if (el.matches('[data-dt-radio]')) return ekle('secim', { d: el.value === 'duzenli' ? 'Abonelik (düzenli teslimat)' : 'Tek seferlik alım' });
        if (el.matches('[data-duzenli-hafta]')) return ekle('secim', { d: 'Teslimat sıklığı: ' + kirp(el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : el.value, 40) });
        if (el.matches('input[type="checkbox"], input[type="radio"], select')) {
          var lb = el.closest('label') || (el.id && document.querySelector('label[for="' + el.id + '"]'));
          var ad = kirp((lb && lb.textContent) || el.getAttribute('aria-label') || el.name || '', 60);
          var deger = el.matches('select') ? kirp(el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '', 40)
            : (el.type === 'checkbox' ? (el.checked ? 'işaretledi' : 'kaldırdı') : 'seçti');
          if (ad || deger) ekle('secim', { d: (ad ? ad + ': ' : '') + deger });
        }
      } catch (e) {}
    }, true);

    // 6) Arama (yalnız arama kutusunun metni) + "Ödemeye geç" (sepet formu; değeri son bilinen sepetten)
    document.addEventListener('submit', function (ev) {
      try {
        var f = ev.target;
        if (f && f.querySelector && f.querySelector('[name="checkout"]')) { ekle('odeme_tik', sonSepet); gonder(); return; }
        var q = f && f.querySelector && f.querySelector('input[type="search"], input[name="q"]');
        if (q && q.value) ekle('arama', { d: kirp(q.value, 80), satilmiyor: q.hasAttribute('data-satilmiyor') ? 1 : null });
      } catch (e) {}
    }, true);
    // Öneri penceresinde "Bunu şu an satmıyoruz" çıktı (header.js, yazmayı bırakınca bir kez) — Enter'a basmasa da talep kaydı
    document.addEventListener('petidi:arama-satilmiyor', function (ev) {
      try { var dt = ev.detail || {}; if (dt.q) ekle('arama', { d: kirp(dt.q, 80), satilmiyor: 1, k: dt.k || 'oneri' }); } catch (e) {}
    });

    // A/B yaşam görseli: sepet özelliği (_ab_yasam) yazılamadı (product.js abYasamSepet) — sessiz kalmasın
    document.addEventListener('petidi:ab-hata', function (ev) {
      try { ekle('ab_hata', { d: kirp((ev.detail || {}).d || 'hata', 80), abt: abYasam() }); } catch (e) {}
    });

    // Ödemeden dönene WhatsApp yardım satırı (18 Eki 2026, main-cart): görüldü / tıklandı / kapattı
    document.addEventListener('petidi:sepet-yardim', function (ev) {
      try {
        var d = { gosterildi: 'WhatsApp yardım satırı gösterildi (ödemeden döndü)', tiklandi: "WhatsApp yardım satırına tıkladı", kapatti: 'WhatsApp yardım satırını kapattı' }[(ev.detail || {}).d];
        if (!d) return;
        ekle('sepet_yardim', { d: d });
        if ((ev.detail || {}).d === 'tiklandi') gonder();
      } catch (e) {}
    });

    // 7) Sepet istekleri — tema kodlarına dokunmadan tarayıcının ağ kaydından (PerformanceObserver)
    try {
      if (window.PerformanceObserver) {
        new PerformanceObserver(function (l) {
          l.getEntries().forEach(function (en) {
            var n = String(en.name || '');
            if (/\/cart\/add(\.js)?(\?|$)/.test(n)) { var abg = abSepet(); sepetIleEkle('sepete', abg ? { abt: abg, abu: C.urun && C.urun.id } : null); }
            else if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(n)) sepetIleEkle('sepet_degisti');
          });
        }).observe({ type: 'resource', buffered: false });
      }
    } catch (e) {}

    // 8) Sayfa hataları (en fazla 3) — "neden almadı"nın bir cevabı olabilir
    // Bizim olmayan hatalar sayılmaz (1 Kas 2026): Instagram/Facebook uygulama içi tarayıcısı (iOS) sayfaya kendi betiğini
    // enjekte ediyor, `_AutofillCallbackHandler` bulunamayınca hata atıyor — sitenin çalışmasını etkilemez, panelde gürültü.
    var YABANCI_HATA = /_AutofillCallbackHandler|webkit\.messageHandlers|instantSearchSDKJSBridgeClearHighlight|Script error\.?$/;
    window.addEventListener('error', function (ev) {
      if (YABANCI_HATA.test(String(ev.message || ''))) return;
      if (hataSay >= 3) return; hataSay++;
      try { ekle('hata', { d: kirp(ev.message || 'hata', 120) }); } catch (e) {}
    });

    // 9) Sekme gizlendi / döndü, çıkış: görünür kalma süresi + en derin nokta
    document.addEventListener('visibilitychange', function () {
      // Sayfadan çıkışta pagehide önce gelir ve 'cikis'i zaten yollar — aynı süre ikinci pakette gitmesin
      if (document.visibilityState === 'hidden') { if (cikisGitti) return; gorunurEkle(); ekle('gizlendi', { sure: gorunurMs }); gonder(); }
      else { gorunurBas = Date.now(); oturumTazele(); if (!cikisGitti) ekle('dondu'); }
    });
    window.addEventListener('pagehide', function () {
      if (cikisGitti) return; cikisGitti = true;
      gorunurEkle(); ekle('cikis', { sure: gorunurMs, kaydir: enDerin, toplam: Date.now() - acilis }); gonder();
    });
    // Arada biriken olaylar 15 sn'de bir gider (çıkış paketi kaybolsa da çoğu yerinde olsun)
    setInterval(function () { if (kuyruk.length) { oturumTazele(); gonder(); } }, 15000);
  } catch (e) {}
})();
